const products = [
  {
    name: "Mixing & Blending Tanks",
    badge: "High Volume",
    desc: "Custom SS304/SS316 mixing tanks for dairy, beverage, sauce, and paste processing. Available with motorised agitators, heating jackets, and CIP spray balls.",
    features: ["Motorised agitator options", "Jacketed heating/cooling", "CIP-compatible spray balls", "Capacity: 200L – 50,000L"],
    image: "/images/food/mixing-tanks.webp",
  },
  {
    name: "Stainless Steel Conveyor Systems",
    badge: "Custom Belt",
    desc: "Hygienic stainless steel conveyor systems for meat, fish, vegetable, bakery, and dairy product handling — designed for washdown and inspection access.",
    features: ["Food-grade belt materials", "Variable speed drive", "Easy washdown access", "Custom lengths & widths"],
    image: "/images/food/conveyor.webp",
  },
  {
    name: "Processing & Cutting Tables",
    badge: "HACCP Ready",
    desc: "Heavy-duty stainless steel processing tables for butcheries, fish plants, bakeries, and food prep areas — with drainage boards, under-shelves, and splashbacks.",
    features: ["Integrated drainage board", "Under-shelf storage", "Adjustable feet levelling", "Wall-mounted splashback option"],
    image: "/images/food/cutting-tables.webp",
  },
  {
    name: "Storage Silos & Hoppers",
    badge: "Bulk Storage",
    desc: "Vertical and conical stainless steel silos for grain, flour, sugar, liquid, and dry ingredient bulk storage — engineered for easy filling, level monitoring, and discharge.",
    features: ["Conical or flat base options", "Level sensor ports", "Pneumatic or gravity outlet", "Capacity: 500L – 100,000L"],
    image: "/images/food/silos.webp",
  },
  {
    name: "Pasteurisation & Heat Exchanger Units",
    badge: "Dairy & Beverage",
    desc: "Plate and tubular heat exchangers and pasteurisation units for dairy, juice, beer, and sauce producers — compliant with temperature-time standards.",
    features: ["PHE or tubular design", "Precise temp control", "CIP cleaning integration", "Flow rates from 500L/hr"],
    image: "/images/food/pasteuriser.webp",
  },
  {
    name: "Filling & Packaging Stations",
    badge: "End-of-Line",
    desc: "Manual and semi-automated stainless steel filling tables, weigh-fill platforms, and sealing stations for liquids, pastes, powders, and solid food products.",
    features: ["Weigh-fill platform option", "Pipe & valve sets included", "Adjustable fill nozzles", "GN pan & container adapters"],
    image: "/images/food/filling.webp",
  },
];

export default function FoodProducts() {
  return (
    <section id="products" className="py-24 bg-gray-50">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 mb-14">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Product Range</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            Equipment We Fabricate
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            Every unit is custom-engineered in our Nairobi workshop using certified food-grade stainless steel,
            then delivered and commissioned by our specialist installation team.
          </p>
        </div>
      </div>

      {/* Products Grid */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div
              key={product.name}
              className="bg-white rounded-lg border border-gray-100 hover:border-teal-200 transition-all duration-300 overflow-hidden group"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-teal-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                  {product.badge}
                </span>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-2">
                  {product.name}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4">{product.desc}</p>

                {/* Features */}
                <ul className="space-y-1 mb-5">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                      <i className="ri-check-line text-teal-600 flex-shrink-0"></i>
                      {f}
                    </li>
                  ))}
                </ul>

                <a
                  href="#inquiry"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center gap-1 text-teal-600 font-semibold text-xs hover:gap-2 transition-all cursor-pointer"
                >
                  Enquire Now <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
